import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { CATEGORIES } from '../../constants/routes';
import SortBy from '../../store/productsSort';
import { changeSorting } from '../../utils/analytics';
import { getValidObject } from '../../utils/objectManipulation';
import SortingOptions from '../SortingOptions/SortingOptions';

import styles from './CategoriesBanner.module.scss';

export default function CategoriesBanner({
  onChangeOrderBy,
  showBySelection,
  numOfProducts,
  categoryName,
  slug,
  subCategoryName,
  isSearch,
  term,
  hideOrderBy = false,
  onlyProducts = '',
}) {
  const router = useRouter();

  function onChangeSorting(e) {
    onChangeOrderBy(e);
    changeSorting(e?.target?.value);
    const query = {
      ...getValidObject('filter', router?.query?.filter),
      ...getValidObject('brand', router?.query?.brand),
      ...getValidObject('sortBy', e.target.value),
    };

    router.push(
      {
        pathname: router.asPath.split('?')[0],
        query,
      },
      undefined,
      { shallow: true }
    );
  }

  useEffect(() => {
    const sortBy = getValidObject('sortBy', router?.query?.sortBy);
    if (!isEmpty(sortBy)) {
      SortBy.update(sortBy.sortBy);
    }
  }, [slug]);

  const firstStep =
    slug && slug[0] !== 'offers' ? (slug[0] !== 'smart' ? `${CATEGORIES}/${slug[0]}` : '/smart') : '/offers';

  return (
    <div className={styles.bannerFooter}>
      <div className={styles.bannerText}>
        {!isSearch && (
          <>
            <Link href="/">
              <a className={styles.bannerLink}>Αρχική</a>
            </Link>
            <p className={styles.text}> &gt; </p>
            <Link href={firstStep}>
              <a className={styles.bannerLink}>{categoryName}</a>
            </Link>

            {slug.length >= 2 && (
              <>
                <p className={styles.text}> &gt; </p>
                <Link href={`${CATEGORIES}/${slug[0]}/${slug[1]}`}>
                  <a className={styles.bannerLink}>{subCategoryName}</a>
                </Link>
              </>
            )}
          </>
        )}
        {isSearch && <p className={styles.bannerLink}>{`Αποτελέσματα Αναζήτησης > ${term}`}</p>}
      </div>
      {onlyProducts && (
        <div className={styles.bannerText}>
          <p className={cn(styles.text, styles.hideOnSmallScreen)}>{onlyProducts}</p>
        </div>
      )}
      {!hideOrderBy && (
        <div className={styles.bannerText}>
          <p className={cn(styles.text, styles.hideOnSmallScreen)}>
            {slug && slug[0] !== 'offers' && slug[0] !== 'smart' && <span>{numOfProducts} Προϊόντα, </span>}
            <span>Ταξινόμηση: </span>
          </p>
          <SortingOptions showBySelection={showBySelection} onChange={onChangeSorting} />
        </div>
      )}
    </div>
  );
}
